import React, { useState, useEffect } from 'react';
import { gql, useQuery } from '@apollo/client';
import '../App.css';
import Tarjeta from './Tarjeta';

import FinalizarVentas from './FinalizarCompra'

const GET_TARJETAS = gql`
query getTarjetas {
    getTarjetas {
        numeroTarjeta
        cvv
        contrasena
        nombreTitular
        contactoTitular
    }
}`;

const GET_PRODUCTO_PROMOCION = gql`
query getProductosPromocion {
  getProductosPromocion {
    _id
    nombre
    imagen
    precio
    codigo
    stock
    cantidad
  }
}`;

function BuscarTarjeta() {
    const [filter, setFilter] = useState({
        nombreTitular: '',
        numeroTarjeta: '',
        cvv: '',
        contactoTitular: ''
    });
    const [selectedCard, setSelectedCard] = useState(null);
    const [inputPassword, setInputPassword] = useState('');
    const [showCard, setShowCard] = useState(false);
    const  [carrito, setCarrito] = useState([]);
     const [carritoLocal, setCarritoLocal] = useState([]);

    const { loading: loadingTargetas, error: errorTarjetas, data : dataTarjetas} = useQuery(GET_TARJETAS);
    const { loading: loadingProductos, error: errorProductos, data: dataProductos } = useQuery(GET_PRODUCTO_PROMOCION, {
  pollInterval: 6000 // cada 3 segundos
});

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const nombreTitularParam = params.get('nombre') || '';
        const numeroTarjetaParam = params.get('numero') || '';
        const cvvParam = params.get('cvv') || '';
        const contactoTitularParam = params.get('contacto') || '';
        
        setFilter({
            nombreTitular: nombreTitularParam.toLowerCase(),
            numeroTarjeta: numeroTarjetaParam,
            cvv: cvvParam,
            contactoTitular: contactoTitularParam.toLowerCase()
        });
    }, []);
  
useEffect(() => {
  const carritoLocal = localStorage.getItem('carrito');
  if (carritoLocal) {
    setCarrito(JSON.parse(carritoLocal));
  }
}, []);
useEffect(() => {
  localStorage.setItem('carrito', JSON.stringify(carrito));
}, [carrito]);

const total = carritoLocal.reduce((total, prod) => {
  const precioCalculado = prod.codigo === "1"
    ? prod.precio * 1000 + 200
    : prod.precio;
  return total + (precioCalculado * prod.cantidad);
}, 0);

const obtenerCantidadTotal = () => {
  return carrito.reduce((acc, prod) => acc + prod.cantidad, 0);
};

const obtenerTotalCarrito = () => {
  return carrito.reduce((total, prod) => {
    const precioCalculado =
      prod.codigo === "1" ? prod.precio * 1000 + 200 : prod.precio;
    return total + precioCalculado * prod.cantidad;
  }, 0);
};

const productosMayor3000 = () => {
  return carrito.filter(prod => prod.precio <= 3000).length;
};



    const agregarAlCarrito = (producto) => {

  // 🔒 Validaciones para PROMOCIÓN
  const cantidadTotal = obtenerCantidadTotal();
  const totalCarrito = obtenerTotalCarrito();
  const productos3000 = productosMayor3000();

  if (
    cantidadTotal >= 5 ||
    totalCarrito >= 50000 ||
    productos3000 >= 5
  ) {
    alert(
    'Su compra no aplica para la promoci{on'
    );
    return;
  }

  // 🚫 si ya existe la promo
  const productoEnCarrito = carrito.find(
    (item) => item._id === producto._id
  );

  if (productoEnCarrito) {
    alert('Este producto es una promoción: solo puedes agregar 1 unidad');
    return;
  }

  // ✅ agregar solo 1 unidad
  if (producto.stock >= 1) {
    setCarrito([...carrito, { ...producto, cantidad: 1 }]);
  } else {
    alert('No hay stock disponible');
  }
};




   const tarjetas = dataTarjetas?.getTarjetas || [];

const filteredData = tarjetas.filter(tarjeta =>
  tarjeta.numeroTarjeta === filter.numeroTarjeta &&
  tarjeta.cvv === filter.cvv
);

const productos = dataProductos?.getProductosPromocion ?? [];


  return (
    <div>
        {filteredData.length > 0 ? (
            <> <center>
                <Tarjeta
                nombreTitular={filteredData[0].nombreTitular}
                numeroTarjeta={filteredData[0].numeroTarjeta}
                cvv={filteredData[0].cvv}
                contactoTitular={filteredData[0].contactoTitular}
            />
            &nbsp;
            <h1>{total}</h1>
<div className="row">
  {productos?.map((producto, index) => (
    <div className="col-1" key={producto.id || index}>
      <div className="card">

        {/* ⭐ Estrella de descuento */}
        <div className="star-badge">
          
         {producto.cantidad}%
         
          &nbsp;
          
        </div>

        <div className="card-body text-center">
         <img src={producto.imagen} alt="" width='100px' height='85px'/>
         <h3>{producto.precio}$</h3>
         <button className='btn btn-primary'  onClick={() => agregarAlCarrito(producto)}>Agregar</button>
        </div>
      </div>
    </div>
  ))}
</div>

            </center>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<FinalizarVentas
  nombreTitular={filteredData[0].nombreTitular}
  numeroTarjeta={filteredData[0].numeroTarjeta}
  cvv={filteredData[0].cvv}
  contactoTitular={filteredData[0].contactoTitular}
/>


            </>
        ) : (
            <p>No se encontró ninguna tarjeta válida</p>
        )}
        
         <ul>
            {carrito.slice().reverse().map((producto, index) => (
              <li
                key={index}
                className="producto-item"
               
              >
                <div className="producto-nombre">
                  <img src={producto.imagen} width="40px" alt="" /> {producto.nombre}
                </div>
                <div className="producto-precio">
                  ${producto.precio}
                </div>
               
                <div className="producto-subtotal">
                  Subtotal: $
                  {producto.codigo === "1"
                    ? ((producto.precio) * producto.cantidad) + 200
                    : producto.precio * producto.cantidad}
                 
                </div>
              </li>
            ))}
          </ul>
    </div>
);

}

export default BuscarTarjeta;
